module.exports = __webpack_public_path__ + "static/media/what-is-workl.cde690c6.svg";